import React, { useState } from 'react';
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from '../firebaseConfig';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import KeyImg from '../Images/keyboard-red.jpg';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

if(!firebase.apps.length){
    firebase.initializeApp(firebaseConfig);
}

const DialogWindow = ({ IsUser, Open, SetOpen, HandleClose }) => {
    const [loginInfo, setLoginInfo] = useState({
        email: '',
        lPassword: '',
        error: ''
    })
    const [signupInfo, setSignupInfo] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        error: ''
    })
    const [recover, setRecover] = useState({
        email: '',
        error: ''
    })
    const [remember, setRemember] = useState(false)
    const [haveAccount, setHaveAccount] = useState(true)
    const [pValidity, setPValidity] = useState(false);
    const [upperV, setUpperV] = useState(false);
    const [lowerV, setLowerV] = useState(false);
    const [minV, setMinV] = useState(false);
    const [numberV, setNumberV] = useState(false);
    const [successOpen, setSuccessOpen] = useState(false);
    const [signupErrorOpen, setSignupErrorOpen] = useState(false);
    const [recoverOpen, setRecoverOpen] = useState(false)
    const [recoverAlert, setRecoverAlert] = useState(false)
    const [recoverErrorAlert, setRecoverErrorAlert] = useState(false)


    const LoginValues = (e) => {
        const UserLoginInfo = {
            ...loginInfo
        }
        UserLoginInfo[e.target.name] = e.target.value;
        setLoginInfo(UserLoginInfo)
    }

    const SignupValues = (e) => {
        const GetUser = {
            ...signupInfo
        }
        GetUser[e.target.name] = e.target.value;
        setSignupInfo(GetUser)
    } 


    const HandlerSignupBtn = () => {
        let ConfirmPassword = document.getElementById('signupConfirmPassword');
        let Password = document.getElementById('signupPassword');
        const Expression = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})")
        let ExpressionValidate = Expression.test(signupInfo.password);
        if(!ExpressionValidate){
            Password.setCustomValidity('Password must be strong')
        }else{
            Password.setCustomValidity('')
        }
        if(signupInfo.password !== signupInfo.confirmPassword){
            ConfirmPassword.setCustomValidity('Password not match')
        }else{
            ConfirmPassword.setCustomValidity('')
        }
    }

    const LoginHandler = (e) => {
        e.preventDefault()
        e.target.reset()
        SignInAuthUser()
       
    }
    const SignupHandler = (e) => {
        e.preventDefault()
        e.target.reset()
        SignupAuthUser()
    }

    const RecoverValues = (e) => {
        const GetUser = {
            ...recover
        }
        GetUser[e.target.name] = e.target.value
        setRecover(GetUser)
    }
    const RecoverSubmit = (e) => {
        e.preventDefault()
        e.target.reset()
        RecoverAuth()
    }
    const RememberMe = () => {
        const RememberCheck = document.getElementById('remember_checkbox');
        if(RememberCheck.checked){
            setRemember(true)
        }else{
            setRemember(false)
        }
    }

    const PasswordValidity = () => {
        let PLength = signupInfo.password.length
        if(PLength >= 6){
            setMinV(true)
        }else{
            setMinV(false)
        }
        if(/[A-Z]/.test(signupInfo.password)){
            setUpperV(true)
        }else{
            setUpperV(false)
        }
        if(/[a-z]/.test(signupInfo.password)){
            setLowerV(true)
        }else{
            setLowerV(false)
        }
        if(/[0-9]/.test(signupInfo.password)){
            setNumberV(true)
        }else{
            setNumberV(false)
        }
        // /[^A-Za-z0-9]/.test - for special character like @# 
    }

    const RecoverHandler = () => {
        SetOpen(false)
        setRecoverOpen(true)
    }
    const GotoSignIn = () => {
        setRecoverOpen(false)
        SetOpen(true)
    }

    const SignupAuthUser = () => {
        firebase.auth().createUserWithEmailAndPassword(signupInfo.email, signupInfo.password)
        .then(() => {
            firebase.auth().currentUser.updateProfile({
                displayName: signupInfo.name
            })
            .then(() => {
                firebase.auth().currentUser.sendEmailVerification()
                .then(() => {
                    setSignupErrorOpen(false)
                    setSuccessOpen(true)
                    SetOpen(false)
                });
            })
        })
        .catch((err) => {
            const GetUser = {
                ...signupInfo
            }
            GetUser.error = err.message
            setSignupInfo(GetUser)
            setSignupErrorOpen(true)
        });
    }

    const SignInAuthUser = () => {
        firebase.auth().signInWithEmailAndPassword(loginInfo.email, loginInfo.lPassword)
        .then(() => {
            remember && firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
            .then(() => {
                setSignupErrorOpen(false)
                SetOpen(false)
                window.location.pathname = '/'
            })
            !remember && firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            .then(() => {
                setSignupErrorOpen(false)
                SetOpen(false)
                window.location.pathname = '/'
            })
        })
        .catch((err) => {
            const getUser = {
                ...loginInfo
            }
            getUser.error = err.message;
            setLoginInfo(getUser);
            setSignupErrorOpen(true)
        });
    }

    const SignInWithGoogle = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
        .then(() => {
            SetOpen(false)
            window.location.pathname = '/'
        })
        .catch((err) => {
            const GetUser = {
                ...signupInfo
            }
            GetUser.error = err.message
            setSignupInfo(GetUser)
            setSignupErrorOpen(true)
        })
    }

    const RecoverAuth = () => {
        firebase.auth().sendPasswordResetEmail(recover.email)
        .then(() => {
            setRecoverErrorAlert(false)
            setRecoverAlert(true)
            setRecoverOpen(false)
        })
        .catch((err) => {
            const GetUser = {
                ...recover
            }
            GetUser.error = err.message
            setRecover(GetUser)
            setRecoverErrorAlert(true)
        });
    }

    return (
        <div>
            <Dialog
                open={recoverOpen} 
                onClose={GotoSignIn} 
                aria-labelledby="form-dialog-title"
                // {...otherProps}
                fullScreen={true}
                PaperProps={{
                    style: {
                    backgroundImage: `linear-gradient(rgba(2, 6, 42, 0.8), rgba(2, 6, 42, 0.8)), url('${KeyImg}')`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    color: 'white',
                    boxShadow: 'none',
                    },
                }}
            >
                <DialogTitle className='text-center' id="form-dialog-title">Reset Password</DialogTitle>
                <DialogContent className='dialog_content'>
                    <form onSubmit={(e) => RecoverSubmit(e)} className='contact_main_area'>
                        <label htmlFor="recoverPassword">Email :</label>
                        <input type="email" name='email' id="recoverPassword" defaultValue='' placeholder='Enter Your Valid Email*' onBlur={RecoverValues} required/>

                        <p className='text-center mb-4'>Go to <span onClick={() => GotoSignIn()} className='contact_login_btn'>Login</span></p>
                        <input type="submit" value='Submit' className='contact_submit'/>
                    </form> 
                </DialogContent>
(
                <DialogActions>
                    <Button onClick={() => setRecoverOpen(false)} variant='contained' color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
                

            </Dialog>
            
            <Dialog 
                open={Open} 
                onClose={HandleClose} 
                aria-labelledby="form-dialog-title"
                // {...otherProps}
                fullScreen={true}
                PaperProps={{
                    style: {
                    backgroundImage: `linear-gradient(rgba(2, 6, 42, 0.8), rgba(2, 6, 42, 0.8)), url('${KeyImg}')`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    color: 'white',
                    boxShadow: 'none',
                    },
                }}
            >
                <DialogTitle className='text-center' id="form-dialog-title">{ haveAccount ? 'Login' : 'Signup' }</DialogTitle>

                {
                    haveAccount ?
                    <DialogContent
                        className='dialog_content'
                    >
                        <form onSubmit={(e) => LoginHandler(e)} className='contact_main_area'>
                            <label htmlFor="loginName">Email :</label>
                            <input type="email" name='email' id="loginName" defaultValue='' placeholder='Enter Your Valid Email*' onBlur={LoginValues} required/>
                            <label htmlFor="loginPassword">Password :</label>
                            <input type="password" name='lPassword' id="loginPassword" defaultValue='' placeholder='Enter Your Password*' onBlur={LoginValues} required/>
                            <p className='text-center mb-4'>If you have no account <span onClick={() => setHaveAccount(false)} className='contact_login_btn'>signup</span> first</p>
                            <input type="submit" value='Submit' className='contact_submit'/>
                        </form> 
                        <div className="forgot_main_container">
                            <div>
                                <input type="checkbox" name="remember" id="remember_checkbox" onClick={() => RememberMe()} /> Remember me
                            </div>
                            <div>
                                <h1 onClick={() => RecoverHandler()}>Forgot Password</h1>
                            </div>
                        </div>
                        <h5 className='signUp_or text-lg'>OR</h5>
                        <div className="google_login_main_area" onClick={() => SignInWithGoogle()}>
                            <svg className='svg_google_icon' height="100%" viewBox="0 0 20 20" width="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z" fill="#4285F4"></path><path d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z" fill="#34A853"></path><path d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z" fill="#FBBC05"></path><path d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z" fill="#EA4335"></path></svg>
                            <h1>Login With Google</h1>
                        </div>
                    </DialogContent> :

                    <DialogContent
                        className='dialog_content'
                    >
                        <form onSubmit={(e) => SignupHandler(e)} className='contact_main_area'>
                            <label htmlFor="signupName">Name :</label>
                            <input type="text" name='name' id="signupName" placeholder='Enter Your Full Name*' defaultValue='' onChange={SignupValues} required/>
                            <label htmlFor="signupEmail">Email :</label>
                            <input type="email" name='email' id="signupEmail" placeholder='Enter Your Email*' defaultValue='' onChange={SignupValues} required/>
                            <label htmlFor="signupPassword">Password :</label>
                            <input type="password" name='password' id="signupPassword" minLength='6' maxLength='16' defaultValue='' placeholder='Enter a Password*' onFocus={() => setPValidity(true)} onChange={SignupValues} onBlur={() => setPValidity(false)} onKeyUp={PasswordValidity} required/>
                            <div className={`password_policies ${pValidity ? 'password_policies_active' : ''}`}>
                                <div className={`policy_length ${minV ? 'validate' : ''}`}>
                                    Min 6 Characters
                                </div>
                                <div className={`policy_number ${numberV ? 'validate' : ''}`}>
                                    Contains Number
                                </div>
                                <div className={`policy_uppercase ${upperV ? 'validate' : ''}`}>
                                    Contains Uppercase
                                </div>
                                <div className={`policy_lowercase ${lowerV ? 'validate' : ''}`}>
                                    Contains Lowercase
                                </div>
                            </div>
                            <label htmlFor="signupConfirmPassword">Confirm Password :</label>
                            <input type="password" name='confirmPassword' id="signupConfirmPassword" defaultValue='' placeholder='Retype Your Password*' onChange={SignupValues} required/>
                            <p className='text-center mb-4'>Already have an account. <span onClick={() => setHaveAccount(true)} className='contact_login_btn'>login</span></p>
                            <input type="submit" value='Submit' className='contact_submit' onClick={HandlerSignupBtn}/>
                        </form>
                        <h5 className='signUp_or text-lg'>OR</h5>
                        <div className="google_login_main_area" onClick={() => SignInWithGoogle()}>
                            <svg className='svg_google_icon' height="100%" viewBox="0 0 20 20" width="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z" fill="#4285F4"></path><path d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z" fill="#34A853"></path><path d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z" fill="#FBBC05"></path><path d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z" fill="#EA4335"></path></svg>
                            <h1>Signup With Google</h1>
                        </div>
                    </DialogContent>
                }


                <DialogActions>
                    <Button onClick={HandleClose} variant='contained' color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={successOpen} autoHideDuration={8000}>
                <Alert onClose={() => setSuccessOpen(false)} severity="success">
                We have sent a link to your email to verify your email address
                </Alert>
            </Snackbar>
            <Snackbar open={signupErrorOpen} autoHideDuration={8000}>
                <Alert onClose={() => setSignupErrorOpen(false)} severity="error">
                {signupInfo.error || loginInfo.error}
                </Alert>
            </Snackbar>
            <Snackbar open={recoverAlert} autoHideDuration={8000}>
                <Alert onClose={() => setRecoverAlert(false)} severity="success">
                We have sent a email to reset your password
                </Alert>
            </Snackbar>
            <Snackbar open={recoverErrorAlert} autoHideDuration={8000}>
                <Alert onClose={() => setRecoverErrorAlert(false)} severity="error">
                {recover.error}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default DialogWindow;